package kz.dentalcrm.app.data.network.response_model.quick_replies

import kotlinx.serialization.Serializable

@Serializable
data class QuickReply(
    val id: Int,
    val message: String? = null
)